function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMvp003(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 950 400",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.58777,0,0,1.58777,-225.46,-242.515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.37,246.689L164.066,246.689C161.248,230.395 161.248,213.737 164.066,197.443L205.37,197.443C200.717,213.527 200.717,230.605 205.37,246.689Z",
    style: {
      fill: "rgb(255,101,132)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.58777,0,0,1.58777,-225.46,-242.515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.128,267.667L282.431,267.667C285.25,251.373 285.25,234.715 282.431,218.42L241.128,218.42C245.781,234.505 245.781,251.583 241.128,267.667Z",
    style: {
      fill: "rgb(230,230,230)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.58777,0,0,1.58777,-225.46,-242.515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M507.67,277.737L563.796,277.737C564.599,277.709 565.245,277.04 565.245,276.237C565.245,275.433 564.599,274.764 563.796,274.737L507.67,274.737C506.867,274.764 506.221,275.433 506.221,276.237C506.221,277.04 506.867,277.709 507.67,277.737Z",
    style: {
      fill: "rgb(230,230,230)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.58777,0,0,1.58777,-225.46,-242.515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M562.337,263.585L571.106,271.589C572.109,272.504 574.868,274.394 575.491,275.591C576.779,278.066 575.395,277.501 573.187,278.358C567.763,280.517 562.764,283.621 558.424,287.526C556.972,288.805 559.101,290.92 560.545,289.647C564.503,286.09 569.051,283.248 573.985,281.251C575.754,280.552 579.11,280.142 579.951,278.035C580.979,275.456 577.703,273.553 576.151,272.136L564.459,261.464C563.035,260.164 560.908,262.28 562.337,263.585L562.337,263.585Z",
    style: {
      fill: "rgb(230,230,230)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.58777,0,0,1.58777,-225.46,-242.515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.128,338.667L234.431,338.667C237.25,322.373 237.25,305.715 234.431,289.42L193.128,289.42C197.781,305.505 197.781,322.583 193.128,338.667Z",
    style: {
      fill: "rgb(108,99,255)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.58777,0,0,1.58777,-225.46,-242.515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M514.128,242.667L555.431,242.667C558.25,226.373 558.25,209.715 555.431,193.42L514.128,193.42C518.781,209.505 518.781,226.583 514.128,242.667Z",
    style: {
      fill: "rgb(108,99,255)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.58777,0,0,1.58777,-46.7702,-13.7925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.825,179.533L270.825,57.985L259.825,55.533L259.825,190.533L342.825,189.684L342.545,178.8L270.825,179.533Z",
    style: {
      fill: "rgb(242,242,242)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.58777,0,0,1.58777,-225.46,-242.515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M465.367,344.737L365.367,344.737L365.367,183.737L465.367,183.737L465.367,344.737ZM367.367,342.737L463.367,342.737L463.367,185.737L367.367,185.737L367.367,342.737Z",
    style: {
      fill: "rgb(63,61,86)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.58777,0,0,1.58777,-46.7702,-13.7925)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 261.825,
    y: 49.684,
    width: 16.197,
    height: 2,
    style: {
      fill: "rgb(63,61,86)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.58777,0,0,1.58777,-46.7702,-13.7925)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 261.825,
    y: 54.684,
    width: 16.197,
    height: 2,
    style: {
      fill: "rgb(63,61,86)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.58777,0,0,1.58777,-46.7702,-13.7925)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 261.825,
    y: 59.684,
    width: 16.197,
    height: 2,
    style: {
      fill: "rgb(63,61,86)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.58777,0,0,1.58777,-46.7702,-13.7925)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 269.825,
    y: 145.684,
    width: 69.197,
    height: 2,
    style: {
      fill: "rgb(63,61,86)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.58777,0,0,1.58777,-46.7702,-13.7925)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 269.825,
    y: 156.684,
    width: 69.197,
    height: 2,
    style: {
      fill: "rgb(63,61,86)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.58777,0,0,1.58777,-46.7702,-13.7925)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 269.825,
    y: 167.684,
    width: 69.197,
    height: 2,
    style: {
      fill: "rgb(63,61,86)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.58777,0,0,1.58777,-225.46,-242.515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M450.367,206.737C446.527,206.737 443.367,203.577 443.367,199.737C443.367,195.896 446.527,192.737 450.367,192.737C454.207,192.737 457.367,195.896 457.367,199.737C457.363,203.575 454.206,206.732 450.367,206.737ZM450.367,194.737C447.624,194.737 445.367,196.994 445.367,199.737C445.367,202.479 447.624,204.737 450.367,204.737C453.11,204.737 455.367,202.479 455.367,199.737C455.364,196.995 453.109,194.74 450.367,194.737Z",
    style: {
      fill: "rgb(63,61,86)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.58777,0,0,1.58777,-225.46,-242.515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452.367,266.737L381.367,266.737L381.367,220.737L452.367,220.737L452.367,266.737ZM383.367,264.737L450.367,264.737L450.367,222.737L383.367,222.737L383.367,264.737Z",
    style: {
      fill: "rgb(63,61,86)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.853697,-1.33874,1.33874,0.853697,-245.746,494.485)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 415.867,
    y: 202.819,
    width: 2,
    height: 81.835,
    style: {
      fill: "rgb(63,61,86)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33875,-0.853676,0.853676,1.33875,-329.724,174.05)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 375.949,
    y: 242.736,
    width: 81.835,
    height: 2,
    style: {
      fill: "rgb(63,61,86)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.58777,0,0,1.58777,-46.7702,-13.7925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M524.825,179.533L524.825,57.985L513.825,55.533L513.825,190.533L596.825,189.684L596.545,178.8L524.825,179.533Z",
    style: {
      fill: "rgb(242,242,242)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.58777,0,0,1.58777,-225.46,-242.515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M720.367,342.737L620.367,342.737L620.367,181.737L720.367,181.737L720.367,342.737ZM622.367,340.737L718.367,340.737L718.367,183.737L622.367,183.737L622.367,340.737Z",
    style: {
      fill: "rgb(63,61,86)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.58777,0,0,1.58777,-46.7702,-13.7925)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 516.825,
    y: 47.684,
    width: 16.197,
    height: 2,
    style: {
      fill: "rgb(63,61,86)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.58777,0,0,1.58777,-46.7702,-13.7925)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 516.825,
    y: 52.684,
    width: 16.197,
    height: 2,
    style: {
      fill: "rgb(63,61,86)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.58777,0,0,1.58777,-46.7702,-13.7925)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 516.825,
    y: 57.684,
    width: 16.197,
    height: 2,
    style: {
      fill: "rgb(63,61,86)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.58777,0,0,1.58777,-225.46,-242.515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M705.367,204.737C701.527,204.737 698.367,201.577 698.367,197.737C698.367,193.896 701.527,190.737 705.367,190.737C709.207,190.737 712.367,193.896 712.367,197.737C712.363,201.575 709.205,204.732 705.367,204.737ZM705.367,192.737C702.624,192.737 700.367,194.994 700.367,197.737C700.367,200.479 702.624,202.737 705.367,202.737C708.11,202.737 710.367,200.479 710.367,197.737C710.364,194.995 708.109,192.74 705.367,192.737Z",
    style: {
      fill: "rgb(63,61,86)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.58777,0,0,1.58777,-225.46,-242.515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M707.367,264.737L636.367,264.737L636.367,218.737L707.367,218.737L707.367,264.737ZM638.367,262.737L705.367,262.737L705.367,220.737L638.367,220.737L638.367,262.737Z",
    style: {
      fill: "rgb(63,61,86)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.85369,-1.33874,1.33874,0.85369,-55.8787,834.396)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 670.867,
    y: 200.819,
    width: 2,
    height: 81.835,
    style: {
      fill: "rgb(63,61,86)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33884,-0.853539,0.853539,1.33884,-264.542,391.126)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 630.949,
    y: 240.736,
    width: 81.835,
    height: 2,
    style: {
      fill: "rgb(63,61,86)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.58777,0,0,1.58777,-225.46,-242.515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M707.367,324.737L636.367,324.737L636.367,278.737L707.367,278.737L707.367,324.737ZM638.367,322.737L705.367,322.737L705.367,280.737L638.367,280.737L638.367,322.737Z",
    style: {
      fill: "rgb(63,61,86)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.85369,-1.33874,1.33874,0.85369,-136.203,878.441)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 670.867,
    y: 260.819,
    width: 2,
    height: 81.835,
    style: {
      fill: "rgb(63,61,86)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33884,-0.853539,0.853539,1.33884,-315.755,406.062)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 630.949,
    y: 300.736,
    width: 81.835,
    height: 2,
    style: {
      fill: "rgb(63,61,86)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.58777,0,0,1.58777,-225.46,-242.515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400.128,375.667L441.431,375.667C444.25,359.373 444.25,342.715 441.431,326.42L400.128,326.42C404.781,342.505 404.781,359.583 400.128,375.667Z",
    style: {
      fill: "rgb(108,99,255)",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMvp003);
export default __webpack_public_path__ + "static/media/mvp-003.d9ebdc4235e44e1bda0668269ff35634.svg";
export { ForwardRef as ReactComponent };